import React, { useState } from "react";
import "./ContactCOnSection.css";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
 
const ContactSection = () => {
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  message: ""
});
 
  const [loading, setLoading] = useState(false);
 
  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
 
  // Submit form
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const formDataObj = new FormData();

    // Append all form fields
    Object.keys(formData).forEach((key) => {
      formDataObj.append(key, formData[key]);
    });

    const res = await fetch("https://novaedubridge.com/contact.php", {
      method: "POST",
      body: formDataObj,
    });

    const result = await res.json();
    alert(result.message);

    // Reset form on success
    if (result.status === "success") {
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong. Please try again later.");
  } finally {
    setLoading(false);
  }
};
 
  return (
    <div className="contactt-container">
      {/* Left side - Info */}
      <div className="contactt-info">
        <h2>Contact Us</h2>
    <p>
  We are committed to processing your information to contact you and guide you through the best 
 <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}> Study Abroad Programs in Bangalore</Link>  tailored to your goals.
</p>
 
        <div className="contactt-item">
          <MdEmail className="icon" />
          <span>
            <a href="mailto:info@novaedubridge.com">info@novaedubridge.com</a>
          </span>
        </div>
 
        <div className="contactt-item">
          <MdLocationOn className="icon" size={50}/>
          <span>
            No.121, 1st Floor, Eshwar Plaza, 4th Main Road, 1st Phase, 1st Stage,
            Manjunatha Nagar, West of Cord Road, Bangalore-560010.
          </span>
        </div>
 
        <div className="contactt-item">
          <FaPhoneAlt className="icon" />
          <span>
            Lets Talk: <a href="tel:+919902043004">+91 99020 43004</a>
          </span>
        </div>
      </div>
 
      {/* Right side - Form */}
      <div className="contactt-form">
        <form onSubmit={handleSubmit}>
  <input
    type="text"
    name="name"
    placeholder="Name*"
    value={formData.name}
    onChange={handleChange}
    required
  />

  <input
    type="email"
    name="email"
    placeholder="Email*"
    value={formData.email}
    onChange={handleChange}
    required
  />

 <input
  type="tel"
  name="phone"
  placeholder="Phone Number*"
  value={formData.phone}
  onChange={handleChange}
  pattern="[0-9]{10}"
  maxLength="10"
  required
/>

  <textarea
    name="message"
    placeholder="Message"
    rows="5"
    value={formData.message}
    onChange={handleChange}
    required
  ></textarea>

  <button type="submit" disabled={loading}>
    {loading ? "Submitting..." : "Submit"}
  </button>
</form>
      </div>
    </div>
  );
};
 
export default ContactSection;
